import React from 'react';

interface FormSelectProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: Array<{ value: string; label: string }>;
  placeholder?: string;
  required?: boolean;
}

export default function FormSelect({
  id,
  label,
  value,
  onChange,
  options,
  placeholder,
  required = false
}: FormSelectProps) {
  return (
    <div>
      <label htmlFor={id} className="block text-supporting font-medium text-gray-700 mb-2">
        {label} {required && <span className="text-error-red">*</span>}
      </label>
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full px-4 py-3 border border-border-light rounded-md text-body-lg focus:ring-2 focus:ring-trust-blue/20 focus:border-trust-blue transition-all duration-200 font-inter bg-pure-white"
        required={required}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}